import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Box, Checkbox, FormControl, FormControlLabel, FormHelperText, InputLabel, styled } from '@mui/material';
import { pxToRem } from '@themes';
var StyledFormControl = styled(FormControl)(function (_ref) {
  var fullWidth = _ref.fullWidth;
  var styles = {
    display: fullWidth && 'flex',
    maxWidth: '100%'
  };
  return styles;
});
var StyledCheckboxBase = styled(Checkbox, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'fullWidth';
  }
})(function (_ref2) {
  var _styles;

  var theme = _ref2.theme,
      color = _ref2.color;
  var styles = (_styles = {
    color: theme.colors.white,
    padding: theme.spacing(1)
  }, _defineProperty(_styles, '&.Mui-checked .MuiSvgIcon-root', {
    color: theme.colors.funGreen
  }), _defineProperty(_styles, '& .MuiSvgIcon-root', {
    height: pxToRem(20)
  }), _styles);
  return styles;
});
var StyledInputLabel = styled(InputLabel)(function (_ref3) {
  var theme = _ref3.theme,
      $color = _ref3.$color;
  var styles = {
    position: 'relative',
    transform: 'unset',
    transformOrigin: 'unset',
    maxWidth: '100%',
    fontSize: pxToRem(16),
    lineHeight: pxToRem(18),
    fontWeight: 400,
    color: theme.colors.comet,
    display: 'block',
    paddingLeft: theme.spacing(1),
    marginBottom: theme.spacing(0.5)
  };
  return styles;
});
var StyleFromHelperWrapper = styled(Box)(function () {
  var styles = {
    position: 'absolute',
    left: 0,
    right: 0,
    top: '100%',
    marginTop: pxToRem(4),
    fontSize: pxToRem(12),
    lineHeight: pxToRem(14)
  };
  return styles;
});
var StyledFormHelperErrorText = styled(FormHelperText)(function (_ref4) {
  var theme = _ref4.theme;
  var styles = {
    '&&': {
      color: theme.colors.bitterSweet,
      display: 'block',
      padding: theme.spacing(0, 1),
      margin: 'unset',
      maxWidth: '100%'
    }
  };
  return styles;
});
var StyledFormHelperText = styled(FormHelperText)(function (_ref5) {
  var theme = _ref5.theme,
      $color = _ref5.$color;
  var styles = {
    color: theme.colors.comet,
    display: 'block',
    padding: theme.spacing(0, 1),
    margin: 'unset',
    maxWidth: '100%'
  };
  return styles;
});
var StyledCheckboxLabel = styled(FormControlLabel)(function (_ref6) {
  var theme = _ref6.theme,
      $labelAlign = _ref6.$labelAlign;
  var styles = {
    marginRight: 0,
    '&.Mui-disabled': {
      cursor: 'not-allowed'
    }
  };

  if ($labelAlign === 'top') {
    styles.alignItems = 'flex-start';
  }

  return styles;
});
export { StyledCheckboxBase, StyledCheckboxLabel, StyledFormControl, StyledFormHelperErrorText, StyledFormHelperText, StyledInputLabel, StyleFromHelperWrapper };